import React, { FC, SVGAttributes } from "react"
import SVG from "../svg"

const Ghost: FC<SVGAttributes<SVGElement>> = (props) => {
    return (
        <SVG
            viewBox="0 0 512 512"
            {...props}
        >
            <path
                fillRule="evenodd"
                d="M368.952 510.227c-46.183 2.364-99.056 2.364-117.024 0C111.77 491.788 0 389.313 0 250.8 0 112.287 114.615 0 256 0s256 112.287 256 250.8c0 64.421-24.793 123.169-65.54 167.587-11.065 12.061 4.117 20.521 19.542 29.117 15.128 8.431 30.49 16.992 21.562 29.208-9.838 13.461-63.172 30.677-118.612 33.515zM220 219.45c0 21.642-17.909 39.187-40 39.187s-40-17.545-40-39.187c0-14.515 8.055-27.186 20.024-33.959.689 18.871 16.205 33.958 35.245 33.958H220v.001zm123.976-33.959c-.689 18.871-16.205 33.958-35.245 33.958H284v.001c0 21.642 17.909 39.187 40 39.187s40-17.545 40-39.187c0-14.515-8.055-27.186-20.024-33.959z"
                clipRule="evenodd"
            ></path>
        </SVG>
    )
}

export default Ghost
